export const faultQuestions = [
  'The power supply?',
  'A control circuit?',
  'A safety device?',
  'A relay?',
  'A contactor?',
  'An electrical connection?',
  'A component missing its expected control signal?',
];

export const painPoints = [
  'You’re switching between components without a documented diagnostic sequence.',
  'You’re spending unnecessary time deciding which verification step comes next.',
  'You’re struggling to connect wiring diagrams with observed equipment behavior.',
  'You’re recording measurements without a consistent documentation structure.',
  'You’re relying on memory instead of a repeatable troubleshooting workflow.',
  'You’re finding it difficult to communicate your findings clearly.',
];

export const beforeItems = [
  'Jumping between components without a clear investigation plan.',
  'Reviewing wiring diagrams without a consistent interpretation workflow.',
  'Repeating checks because previous findings weren’t organized.',
  'Investigating control circuits without documented decision points.',
  'Recording electrical measurements in scattered notes.',
  'Finishing an investigation without a clear summary of findings.',
];

export const afterItems = [
  'Follow a defined five-stage diagnostic organization system.',
  'Connect equipment symptoms with relevant electrical circuits.',
  'Identify appropriate verification checkpoints before proceeding.',
  'Organize control-circuit investigations using decision trees.',
  'Record electrical findings in structured worksheets.',
  'Produce a professional troubleshooting summary with documented next steps.',
];
